import {
  AnalyticsDimensionForUiNames,
  CachedAnalytics,
  DimensionValue,
} from 'common/src/modules/analytics/analytics.types';
import Subject from 'common/src/utils/pubsub/subject';

const cachedAnalyticsSubject = new Subject<CachedAnalytics>({
  uiNameMapping: {},
  optionsByMetricsKey: {},
  analyticsUiNamesLoaded: false,
  metaConversionsLoaded: false,
  isLoading: false,
  hasMetaCustomConversions: false,
  dimensionUiMetadataMap: {} as Record<DimensionValue, AnalyticsDimensionForUiNames>,
});

export {cachedAnalyticsSubject};
